'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delete = require('unmutable/lib/delete');

var _delete2 = _interopRequireDefault(_delete);

var _get = require('unmutable/lib/get');

var _get2 = _interopRequireDefault(_get);

var _isEmpty = require('unmutable/lib/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _pipe = require('unmutable/lib/util/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return function (newData) {
        // remove child object if it is undefined or empty
        if (typeof (0, _get2.default)('child')(newData) === "undefined" || (0, _pipe2.default)((0, _get2.default)('child'), (0, _isEmpty2.default)())(newData)) {
            newData = (0, _delete2.default)('child')(newData);
        }

        // remove key if it is undefined
        if (typeof (0, _get2.default)('key')(newData) === "undefined") {
            newData = (0, _delete2.default)('key')(newData);
        }

        // remove meta if it is undefined or empty
        if (typeof (0, _get2.default)('meta')(newData) === "undefined" || (0, _pipe2.default)((0, _get2.default)('meta'), (0, _isEmpty2.default)())(newData)) {
            newData = (0, _delete2.default)('meta')(newData);
        }

        return newData;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/strip.js
// module id = 346
// module chunks = 35783957827783